import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { CCol, CRow } from '@coreui/react-pro';

import { CART_TYPES, SUBSCRIBER_PATH, TAB_SELECT_PURCHASE } from '../../../../../constants';
import { getFileData, scrollToTopOffset } from '../../../../../utils';

import CenterSpinner from '../../../../General/Loadings/CenterSpinner';
import { Media } from '../../../../General/Media';

import AvailableTrainingDates from './AvailableTrainingDates';
import TrainingProductCard from './TrainingProductCard/TrainingProductCard';

import { fetchSubscriberSellingGroupsRequest } from '../actions';

export const fetchSellingGroupDataDetail = (sellingGroups, optionSelect = TAB_SELECT_PURCHASE.PERSONAL_TRAINING) => {
     if (!sellingGroups.length) return [];

     const sellingGroupListOfUser = [];
     const sellingGroupsOfOrg = [];

     for (let i = 0; i < sellingGroups.length; i++) {
          const sellingGroup = sellingGroups[i];
          const products = sellingGroup.products;

          const sellingGroupMapping = {
               id: sellingGroup.id,
               sellingGroupCategoryId: sellingGroup.sellingGroupCategoryId,
               name: sellingGroup.name,
               slug: sellingGroup.slug,
               headline: sellingGroup.headline,
               subHeadline: sellingGroup.subHeadline,
               headlineDetail: sellingGroup.headlineDetail,
               subHeadlineDetail: sellingGroup.subHeadlineDetail,
               shortDescription: sellingGroup.shortDescription,
               description: sellingGroup.description,
               image: sellingGroup.image,
               status: sellingGroup.status,
               sortingOder: sellingGroup.sortingOder,
               createdAt: sellingGroup.createdAt,
          };
          const sellingGroupOfUser = {
               ...sellingGroupMapping,
               products: [],
          };
          const sellingGroupOfOrg = {
               ...sellingGroupMapping,
               products: [],
          };

          for (let j = 0; j < products.length; j++) {
               const product = products[j];

               if (product.purchaseType === CART_TYPES.INVISIBLE) {
                    continue;
               }

               if (product.purchaseType !== CART_TYPES.ORGANIZATION) {
                    sellingGroupOfUser.products.push(product);
               }

               if (product.purchaseType !== CART_TYPES.INDIVIDUAL) {
                    sellingGroupOfOrg.products.push(product);
               }
          }

          sellingGroupListOfUser.push(sellingGroupOfUser);
          sellingGroupsOfOrg.push(sellingGroupOfOrg);
     }

     if (optionSelect === TAB_SELECT_PURCHASE.PERSONAL_TRAINING) {
          return sellingGroupListOfUser;
     }

     return sellingGroupsOfOrg;
};

const SellingGroupDetails = () => {
     const dispatch = useDispatch();
     const navigate = useNavigate();
     const slug = useParams().slug;

     const sellingGroups = useSelector((state) => state.subscriber.sellingGroups);
     const [isLoading, setIsLoading] = useState(true);

     const sellingGroup = sellingGroups.find((item) => item.slug === slug);

     const fetchSellingGroups = async () => {
          await dispatch(fetchSubscriberSellingGroupsRequest());
          setIsLoading(false);
     };

     useEffect(() => {
          scrollToTopOffset();
          fetchSellingGroups();
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     const fileData = sellingGroup?.image ? getFileData(sellingGroup.image) : {};
     const flagTypeFile = ['jpg', 'jpeg', 'png', 'jfif', 'webp', 'gif', 'svg'];
     const isImage = fileData.extension && flagTypeFile.includes(fileData.extension.toLowerCase());

     const bookGroupStagingId = '1474c330-5fca-4e56-a13b-04dfc0b06e88-1655957150689';
     const bookGroupDevId = 'ee211610-1156-2d0f-9e85-cdfea89d10f1-8b531d9f4fa15';
     const bookGroupLocalId = '9901127a-7db9-4552-a12a-10a1b2060a16-1661131213291';
     const thirdBookGroupLiveId = 'e1a34da3-a6a5-45e2-8aa2-b6ea9381e66e-1688392661899';
     const bookGroupIds = [bookGroupStagingId, bookGroupDevId, bookGroupLocalId, thirdBookGroupLiveId];
     const isBookGroup = bookGroupIds.includes(sellingGroup?.id);

     if (isLoading) {
          return <CenterSpinner classNameWrap="pt-5" />;
     } else if (!sellingGroup) {
          navigate(SUBSCRIBER_PATH.SELLING_GROUPS);
          return null;
     }

     return (
          <section className="selling-group-detail">
               <div className="container">
                    <CRow>
                         <CCol lg={12} xl={6}>
                              <div
                                   className={`training-intro training-intro-content${isBookGroup && isImage ? ' bookType' : ''} ${
                                        sellingGroup.classSelling
                                   }`}
                              >
                                   <div className="training-intro-wrap">
                                        {isBookGroup && isImage && sellingGroup.image && (
                                             <div className="course-video ">
                                                  <Media src={sellingGroup.image} width={800} height={500} />
                                             </div>
                                        )}

                                        <div className="training-intro-title">
                                             <h1>{sellingGroup.headlineDetail || sellingGroup.headline}</h1>
                                             <h4>{sellingGroup.subHeadlineDetail || sellingGroup.subHeadline}</h4>
                                        </div>
                                        <div className="training-intro-description selling-group-detail-description">
                                             <div className="editor-description" dangerouslySetInnerHTML={{ __html: sellingGroup.description }} />
                                        </div>
                                   </div>

                                   {isBookGroup && !isImage && sellingGroup.image && (
                                        <div className="course-video">
                                             <Media src={sellingGroup.image} width={800} height={500} />
                                        </div>
                                   )}

                                   {!isBookGroup && sellingGroup.image && (
                                        <div className="course-video">
                                             <Media src={sellingGroup.image} width={800} height={500} />
                                        </div>
                                   )}

                                   <AvailableTrainingDates sellingGroup={sellingGroup} />
                              </div>
                         </CCol>
                         <CCol lg={12} xl={6}>
                              <TrainingProductCard />
                         </CCol>
                    </CRow>
               </div>
          </section>
     );
};

export default SellingGroupDetails;
